import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@kolmeo/ui-core";
export const ListTable = ({ data, listRenderItem }) => {
    return (_jsx(_Fragment, { children: _jsx(ListComponent, { data: data, listRenderItem: listRenderItem }) }));
};
const ListComponent = ({ data, listRenderItem }) => {
    return _jsx(Box, { children: data.map((element) => listRenderItem(element)) });
};
export * from "./Table";
